export default "__VITE_ASSET__df189239__"